import { openDialog } from "@/shared/lib/dialog"
import { MockServerConfigDialog } from "../ui/MockServerConfigDialog"

export function openMockServerConfigDialog() {
  openDialog({
    component: MockServerConfigDialog,
  })
}
